<script setup>
import {Head, useForm} from "@inertiajs/inertia-vue3";
import {computed, defineProps, onBeforeUnmount, onMounted, ref, watch} from "vue";
import useUtils from '../Composables/useUtils';
import AuditorioLayoutV2 from "../Layouts/AuditorioLayoutV2";
import {Notify, useQuasar} from "quasar";
import { Inertia } from "@inertiajs/inertia";
import useRotas from "../Composables/useRotas";
import { useModeradorStore } from "@/Stores/moderadorStore";
import useLote from "@/Composables/useLote";
import useAuditorio from "@/Composables/useAuditorio";


const auditorioStore = useModeradorStore();

const route = useRotas();

const $q = useQuasar();

const props = defineProps({
    leilao: Object,
    loteSelecionadoInit: Object,
    lotesInit: Array,
});

const retryConnectSocket = ref(0);
const maxRetryConnectSocket = 5;

const currentState = window.Echo.connector.pusher.connection.state;
const isConnected = ref(currentState === 'connected' || currentState === 'connecting' || currentState === 'initialized');
const onStateChange = (states) => {
    // states.current: 'initialized' | 'connecting' | 'connected' | 'unavailable' | 'failed' | 'disconnected'
    isConnected.value = (states.current === 'connected' || states.current === 'connecting' || states.current === 'initialized');
};
window.Echo.connector.pusher.connection.bind('state_change', onStateChange);

// const autenticado = computed(() => usePage().props.value.auth.autenticado)

const lanceLocal = ref(false);

const idLoteSelecionado = computed(() => auditorioStore.idLoteSelecionadoLeilao[props.leilao.id]);
const lote = computed(() => auditorioStore.lotes[idLoteSelecionado.value]);
const loteSelecionadoAuditorio = computed(() => auditorioStore.lotes[idLoteSelecionado.value]);
const listaLotes = computed(() => auditorioStore.lotes);
const listaLotesOrdenados = computed(() => (Object.values(listaLotes.value || {})).filter(lote => +lote.id_leilao === +props.leilao.id).sort((a, b) => a.sequencia - b.sequencia));
const listaLotesValorVendaOrdenados = computed(() => (Object.values(listaLotes.value || {})).filter(lote => +lote.id_leilao === +props.leilao.id && statusValorVenda.includes(lote.status_lote.identificador)).sort((a, b) => a.sequencia - b.sequencia));
const qtdLances = computed(() => {
    return loteSelecionadoAuditorio.value?.lances?.length || 0;
});

const leilaoSelecionadoAuditorio = computed(() => auditorioStore.leiloes[props.leilao.id]);

const valorLanceAtual = computed(() => {
    return loteSelecionadoAuditorio?.value?.lanceAtual;
});

const valorLanceAtualLances = computed(() => {
    return loteSelecionadoAuditorio?.value?.lances?.[0]?.valor;
});

const { autoplay, slide, timerModerador } = useLote(
    leilaoSelecionadoAuditorio.value,
    lote
);

const {
    formatDate,
    desformatador,
    formatador,
    formatadorLote,
    getImagem
} = useUtils();

let leiloeiroAndou = (e) => {
        abrirLoteAuditorio(e.id);

        setTimeout(() => {
            document.querySelector('.list-parent').scrollLeft = document.querySelector('.list-parent > .atual').offsetLeft - 20
        }, 800);
};

const isNavigating = ref(false);

let leiloeiroMudouLeilao = async (e) => {
    if (!isNavigating.value && +leilaoSelecionadoAuditorio.value?.id === +e.idLeilaoAnterior) {
        isNavigating.value = true;

        Inertia.visit(route('moderador.mod.lote', {
            idLeilao: e.idLeilao
        }));

    }

};

let callbackStatus = (e) => {
    auditorioStore.enfileirar(e);
}

let callbackUpdate = (e) => {
    auditorioStore.enfileirar(e);
}

const conexaoWebSocket = ref(0);
const idLoteAtualSocket = ref(null);
const idLotesValorVendaSocket = ref(new Set());

onMounted(async () => {

    conexaoWebSocket.value = setInterval(() => {
        if(!isConnected.value){
            if (retryConnectSocket.value < maxRetryConnectSocket) {
                retryConnectSocket.value++;
                console.log(`Tentativa de reconexão ${retryConnectSocket.value} de ${maxRetryConnectSocket}`);
                window.Echo.connector.pusher.connect();
            } else {
                Notify.create({
                    message: 'Não foi possível conectar ao servidor de leilões. Por favor, verifique sua conexão com a internet.',
                    icon: 'mdi-alert-circle',
                    color: 'negative',
                    progress: true,
                    timeout: 10000,
                    group: 'erro-conexao'
                });
            }
        }
    }, 15000);

    $q.loading.show({
        message:
            "<p>Carregando Moderador</p>",
        html: true,
    });
    setTimeout(() => {
        $q.loading.hide();
    }, 3000);

    await auditorioStore.carregamentoLeilaoInicial(props.leilao.id);
    await auditorioStore.carregamentoLotesInicial(props.leilao.id);

    if(!idLoteSelecionado.value){
        await abrirLoteAuditorio(props.loteSelecionadoInit.id);
    }

    auditorioStore.processarFila()

    window.Echo.channel("realtime.status.leilao").listen(
        ".leilao." + props.leilao.id + ".status.atualizado",
        (e) => {
            callbackStatus(e);
        }
    );

    window.Echo.channel("realtime.update.leilao").listen(
        ".leilao." + props.leilao.id + ".atualizado",
        (e) => {
            callbackUpdate(e);
        }
    );

    window.Echo.channel("auditorio." + props.leilao.id).listen(
        ".leiloeiroAndou",
        (e) => {
            leiloeiroAndou({ id: e.novoLote, dados: e.dadosNovoLote });
        }
    );

    window.Echo.channel("auditorio").listen(".leiloeiroMudouLeilao", (e) => {
        leiloeiroMudouLeilao({
            idLeilao: e.novoLeilao,
            idLeilaoAnterior: e.leilaoAnterior,
        });
    });

    window.Echo.channel('realtime.mensagemGlobal.somenteModerador').listen('.notificacao', (e) => {

                Notify.create({
                    message: e.mensagem,
                    icon: e.icone,
                    color: e.cor,
                    progress: true,
                    group: e.grupo ? e.grupo : undefined
                });

        });

});

watch(isConnected, (newVal) => {

    if(newVal === false){

        Notify.create({
            message: 'Servidor websocket desconectado. Tentando reconectar...',
            icon: 'mdi-alert-circle',
            color: 'warning',
            progress: true,
            timeout: 10000,
            group: 'erro-conexao'
        });

    } else {

        abrirLoteAuditorio(idLoteSelecionado.value);

        retryConnectSocket.value = 0; // Reseta a contagem de tentativas ao conectar com sucesso
        Notify.create({
            message: 'Conectado ao servidor de leilões.',
            icon: 'mdi-check-circle',
            color: 'positive',
            progress: true,
            timeout: 5000,
            group: 'sucesso-conexao'
        });
    }

});

// Mantém listeners WebSocket para todos os lotes CONDICIONAL/CONDICIONAL_REABERTA que não são o lote atual
watch(listaLotesValorVendaOrdenados, (newLotes, oldLotes) => {
    const oldIds = new Set((oldLotes || []).map(l => l.id));
    const newIds = new Set((newLotes || []).map(l => l.id));

    // Remove listeners de lotes que saíram da lista (e não são o lote atual)
    for (const id of oldIds) {
        if (!newIds.has(id) && id !== idLoteAtualSocket.value) {
            window.Echo.channel('realtime.status.lote')
                .stopListening('.lote.' + id + '.status.atualizado');
            window.Echo.channel('realtime.update.lote')
                .stopListening('.lote.' + id + '.atualizado');
            idLotesValorVendaSocket.value.delete(id);
        }
    }

    // Adiciona listeners para lotes que entraram na lista (e não são o lote atual)
    for (const id of newIds) {
        if (!oldIds.has(id) && id !== idLoteAtualSocket.value) {
            window.Echo.channel('realtime.status.lote')
                .listen('.lote.' + id + '.status.atualizado', (e) => callbackStatus(e));
            window.Echo.channel('realtime.update.lote')
                .listen('.lote.' + id + '.atualizado', (e) => callbackUpdate(e));
            idLotesValorVendaSocket.value.add(id);
        }
    }
});

const abrirLoteAuditorio = (idLote) => {

    auditorioStore.carregamentoLoteMomentoInicial(leilaoSelecionadoAuditorio.value?.id,idLote);
    slide.value = 1; // volta a imagem para a primeira

    lanceLocal.value = false;

    // Remove listeners do lote anterior antes de adicionar novos
    if (idLoteAtualSocket.value) {
        window.Echo.channel('realtime.status.lote')
            .stopListening('.lote.' + idLoteAtualSocket.value + '.status.atualizado');
        window.Echo.channel('realtime.update.lote')
            .stopListening('.lote.' + idLoteAtualSocket.value + '.atualizado');
        // Se o lote anterior ainda está na lista valor-venda, re-registra o listener para ele
        if (idLotesValorVendaSocket.value.has(idLoteAtualSocket.value)) {
            window.Echo.channel('realtime.status.lote')
                .listen('.lote.' + idLoteAtualSocket.value + '.status.atualizado', (e) => callbackStatus(e));
            window.Echo.channel('realtime.update.lote')
                .listen('.lote.' + idLoteAtualSocket.value + '.atualizado', (e) => callbackUpdate(e));
        }
    }
    // Se o novo lote já está sendo ouvido como valor-venda, remove para não duplicar
    if (idLotesValorVendaSocket.value.has(idLote)) {
        window.Echo.channel('realtime.status.lote')
            .stopListening('.lote.' + idLote + '.status.atualizado');
        window.Echo.channel('realtime.update.lote')
            .stopListening('.lote.' + idLote + '.atualizado');
    }
    idLoteAtualSocket.value = idLote;

    window.Echo.channel('realtime.status.lote')
        .listen('.lote.' + idLote + '.status.atualizado', (e) => {
            callbackStatus(e);
        });

    window.Echo.channel('realtime.update.lote')
        .listen('.lote.' + idLote + '.atualizado', (e) => {
            callbackUpdate(e);
        });

};

const valorLanceAuditorio = ref(0);

const voltarPaginaLeilao = () => {
    Inertia.visit(route('leilao', {
        idLeilao: leilaoSelecionadoAuditorio.value?.id
    }));
}

const decodeHtmlEntities = (text) => {
    const entities = {
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&amp;": "&",
    };
    return text.replace(/&lt;|&gt;|&quot;|&amp;/g, (match) => entities[match]);
};
const replaceHmtlIframe = (encodedHtml) => {
    let decodedHtml = encodedHtml;

    if (decodedHtml && decodedHtml.length > 0) {
        const arrayRegex = [
            /&lt;iframe\s+src="https:\/\/www\.google\.com\/maps\/embed[^"]*"[^&]*&gt;&lt;\/iframe&gt;/g,
            /&lt;iframe[^>]*\bsrc="https:\/\/www\.youtube\.com\/embed\/[^"]*"[^>]*&gt;&lt;\/iframe&gt;/g,
        ];

        arrayRegex.forEach((e) => {
            decodedHtml = decodedHtml.replace(e, (match) =>
                decodeHtmlEntities(match)
            );
        });
    }

    return decodedHtml;
};

const descricaoLote = computed(() => replaceHmtlIframe(loteSelecionadoAuditorio.value?.descricao));

watch([valorLanceAtual, valorLanceAtualLances], ([newValorLanceAtual], [oldValorLanceAtual]) => {

    if(newValorLanceAtual !== oldValorLanceAtual){
        valorLanceAuditorio.value = +loteSelecionadoAuditorio?.value?.proximoLance;
        formLancePresencial.valorPresencial = formatador.format(loteSelecionadoAuditorio?.value?.proximoLance);
    }

});

const statusValorVenda = ["CONDICIONAL", "CONDICIONAL_REABERTA"];

const statusIniciarLeilao = ["ABERTO", "ENCERRADO"];
const statusEncerrarLeilao = ["EM_PREGAO"];

const acoesLeilao = {
    iniciarLeilao: async () => {
        await fetch(
            route("moderador.mod.lote.iniciarLeilao", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
                idLote: loteSelecionadoAuditorio.value.id,
            }),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );

    },
    encerrarLeilao: async () => {
        await fetch(
            route("moderador.mod.lote.encerrarLeilao", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
                idLote: loteSelecionadoAuditorio.value.id,
            }),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
    },
    reabrirLeilao: async () => {
        await fetch(
            route("moderador.mod.lote.reabrirLeilao", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
                idLote: loteSelecionadoAuditorio.value.id,
            }),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
    },
    iniciarChatEvento: async () => {
        await fetch(
            route("moderador.mod.lote.iniciarChatEvento", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
            }),
            {
                method: "POST",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": document.head.querySelector(
                        'meta[name="csrf-token"]'
                    ).content,
                },
            }
        );

    },
    interromperChatEvento: async () => {

        await fetch(
            route("moderador.mod.lote.interromperChatEvento", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
            }),
            {
                method: "POST",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": document.head.querySelector(
                        'meta[name="csrf-token"]'
                    ).content,
                },
            }
        );

    },
    iniciarStream: async () => {
    await fetch(
        route("moderador.mod.lote.iniciarStream", {
            idLeilao: leilaoSelecionadoAuditorio.value.id,
        }),
        {
            method: "POST",
            credentials: "include",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": document.head.querySelector(
                    'meta[name="csrf-token"]'
                ).content,
            },
        }
    );
},
    interromperStream: async () => {
        await fetch(
            route("moderador.mod.lote.interromperStream", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
            }),
            {
                method: "POST",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": document.head.querySelector(
                        'meta[name="csrf-token"]'
                    ).content,
                },
            }
        );
    },
};

const acoesLote = {
    retirarLote: async () => {

        await fetch(
            route("moderador.mod.lote.retirarLote", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
                idLote: loteSelecionadoAuditorio.value.id,
            }),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
    },
    pregao: async () => {
        await fetch(
            route("moderador.mod.lote.pregaoLote", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
                idLote: loteSelecionadoAuditorio.value.id,
            }),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
    },
    aberto: async () => {
        await fetch(
            route("moderador.mod.lote.abertoLote", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
                idLote: loteSelecionadoAuditorio.value.id,
            }),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
    },
    doulheUma: async () => {
        await fetch(
            route("moderador.mod.lote.doulheUmaLote", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
                idLote: loteSelecionadoAuditorio.value.id,
            }),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
    },
    doulheDuas: async () => {
        await fetch(
            route("moderador.mod.lote.doulheDuasLote", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
                idLote: loteSelecionadoAuditorio.value.id,
            }),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
    },
    propostaUma: async () => {
        await fetch(
            route("moderador.mod.lote.propostaUmaLote", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
                idLote: loteSelecionadoAuditorio.value.id,
            }),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
    },
    propostaDuas: async () => {
        await fetch(
            route("moderador.mod.lote.propostaDuasLote", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
                idLote: loteSelecionadoAuditorio.value.id,
            }),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
    },
    vendido: async () => {
        await fetch(
            route("moderador.mod.lote.vendidoLote", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
                idLote: loteSelecionadoAuditorio.value.id,
            }),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
    },
    condicional: async () => {
        await fetch(
            route("moderador.mod.lote.condicionalLote", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
                idLote: loteSelecionadoAuditorio.value.id,
            }),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
    },
    repasse: async () => {
        await fetch(
            route("moderador.mod.lote.repasseLote", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
                idLote: loteSelecionadoAuditorio.value.id,
            }),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
    },
    naoVendido: async () => {
        await fetch(
            route("moderador.mod.lote.naoVendido", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
                idLote: loteSelecionadoAuditorio.value.id,
            }),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
    },
    anterior: async () => {
        const atual = listaLotesOrdenados?.value?.findIndex(
            (loteIt) => +loteIt.id === +lote.value.id
        );
        const anterior = listaLotesOrdenados?.value?.[atual - 1];

        await fetch(
            route("moderador.mod.lote.loteAnterior", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
                idLote: anterior.id,
            }),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );

        abrirLoteAuditorio(anterior.id);

    },
    proximo: async () => {

        const atual = listaLotesOrdenados?.value?.findIndex(
            (loteIt) => +loteIt.id === +lote.value.id
        );
        const proximo = listaLotesOrdenados?.value?.[atual + 1];

        await fetch(
            route("moderador.mod.lote.proximoLote", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
                idLote: proximo.id,
            }),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );

        abrirLoteAuditorio(proximo.id);

    },
    irParaLote: async (idLote) => {
        await fetch(
            route("moderador.mod.lote.loteAnterior", {
                idLeilao: leilaoSelecionadoAuditorio.value.id,
                idLote: idLote,
            }),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );

        abrirLoteAuditorio(idLote);

    }
};

const statusVendido = ["DOULHE_DUAS", "PROPOSTA_DUAS"];
const statusCondicional = ["DOULHE_DUAS", "PROPOSTA_DUAS"];

const checkLiberaBotoes = ref((+localStorage.getItem('libera.botoes.moderador') === 1) ? true : false);

const liberaBotoes = () => {
    if(!checkLiberaBotoes.value){
        checkLiberaBotoes.value = false;
        localStorage.setItem('libera.botoes.moderador', 0);
    }else{
        checkLiberaBotoes.value = true;
        localStorage.setItem('libera.botoes.moderador', 1);
    }
}

const visualizarImagens = ref(false);

const confirmExclusaoLance = ref(false);

const form = useForm({
    idLance: null,
});

const mostrarModalRemoverLance = (id) => {
    confirmExclusaoLance.value = true;
    form.idLance = id;
};

const resetaForm = () => {
    form.idLance = null;
};

const removerLance = async () => {
    if (form.idLance) {
        $q.loading.show({
            message: "Excluindo Lance...",
        });
        fetch(
            route("moderador.mod.lance.removerLance", {
                idLeilao: leilaoSelecionadoAuditorio?.value?.id,
                idLote: loteSelecionadoAuditorio?.value?.id,
            }),
            {
                method: "POST",
                credentials: "include",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": document.head.querySelector(
                        'meta[name="csrf-token"]'
                    ).content,
                },
                body: JSON.stringify(form.data()),
            }
        );
        confirmExclusaoLance.value = false;

        $q.loading.hide();
    }

    form.idLance = null;
};


const incrementoLocal = ref( 0);
const lanceInicialLocal = ref(0);
const lanceMinimoLocal = ref(0);

const incrementoLocalSalvo = ref(true);
const lanceInicialLocalSalvo = ref(true);
const lanceMinimoLocalSalvo = ref(true);

const salvarIncremento = async () => {
    $q.loading.show({
        message: "Executando ação solicitada...",
    });
    await fetch(
        route("moderador.mod.lote.atualizarIncremento", {
            idLeilao: leilaoSelecionadoAuditorio?.value?.id,
            idLote: loteSelecionadoAuditorio?.value?.id,
        }),
        {
            method: "POST",
            credentials: "include",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": document.head.querySelector(
                    'meta[name="csrf-token"]'
                ).content,
            },
            body: JSON.stringify({ valor: incrementoLocal.value / 100 }),
        }
    );
    incrementoLocalSalvo.value = true;
    $q.loading.hide();
};

const salvarLanceInicial = async () => {
    $q.loading.show({
        message: "Executando ação solicitada...",
    });
    await fetch(
        route("moderador.mod.lote.atualizarLanceInicial", {
            idLeilao: leilaoSelecionadoAuditorio?.value?.id,
            idLote: loteSelecionadoAuditorio?.value?.id,
        }),
        {
            method: "POST",
            credentials: "include",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": document.head.querySelector(
                    'meta[name="csrf-token"]'
                ).content,
            },
            body: JSON.stringify({ valor: lanceInicialLocal.value / 100 }),
        }
    );
    lanceInicialLocalSalvo.value = true;
    $q.loading.hide();
};

const salvarLanceMinimo = async () => {
    $q.loading.show({
        message: "Executando ação solicitada...",
    });
    await fetch(
        route("moderador.mod.lote.atualizarLanceMinimo", {
            idLeilao: leilaoSelecionadoAuditorio?.value?.id,
            idLote: loteSelecionadoAuditorio?.value?.id,
        }),
        {
            method: "POST",
            credentials: "include",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": document.head.querySelector(
                    'meta[name="csrf-token"]'
                ).content,
            },
            body: JSON.stringify({ valor: lanceMinimoLocal.value / 100 }),
        }
    );
    lanceMinimoLocalSalvo.value = true;
    $q.loading.hide();
};

const incrementoRapido = (valor) => {
    incrementoLocal.value = valor * 100;
    incrementoLocalSalvo.value = false;
};

const disableBtnAvisarValorVenda = computed(() => {
    return !(
        loteSelecionadoAuditorio?.value?.status_lote?.identificador === "CONDICIONAL" &&
        +loteSelecionadoAuditorio?.value?.lance_minimo > +loteSelecionadoAuditorio?.value?.lanceAtual &&
        +loteSelecionadoAuditorio?.value?.lance_minimo >=
        (leilaoSelecionadoAuditorio?.value?.primeiro_leilao_concluido === 1 &&
        +leilaoSelecionadoAuditorio?.value?.dois_leiloes === 1
            ? +loteSelecionadoAuditorio?.value?.lance_inicial_segundo_leilao
            : +loteSelecionadoAuditorio?.value?.lance_inicial)
    );
});

const reabrirCondicionalVenda = async () => {
    $q.loading.show({
        message: "Executando ação solicitada...",
    });
    await fetch(
        route("moderador.mod.lote.reabrirCondicionalVenda", {
            idLeilao: leilaoSelecionadoAuditorio?.value?.id,
            idLote: loteSelecionadoAuditorio?.value?.id,
        }),
        {
            method: "POST",
            credentials: "include",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": document.head.querySelector(
                    'meta[name="csrf-token"]'
                ).content,
            },
        }
    );
    $q.loading.hide();
};

const encerrarCondicionalVenda = async () => {
    $q.loading.show({
        message: "Executando ação solicitada...",
    });
    await fetch(
        route("moderador.mod.lote.encerrarCondicionalVenda", {
            idLeilao: leilaoSelecionadoAuditorio?.value?.id,
            idLote: loteSelecionadoAuditorio?.value?.id,
        }),
        {
            method: "POST",
            credentials: "include",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": document.head.querySelector(
                    'meta[name="csrf-token"]'
                ).content,
            },
        }
    );
    $q.loading.hide();
};

const formLancePresencial = useForm({
    identificacaoPresencial: null,
    valorPresencial: 0,
});

const placaIdentificacaoValida = ref(true);
const mensagemPlacaIdentificacaoValida = ref("");

const incrementarValor = () => {
    formLancePresencial.valorPresencial = formatador.format(
        Number.parseFloat(desformatador(formLancePresencial.valorPresencial)) + loteSelecionadoAuditorio?.value?.incrementoLote
    );
};

const decrementarValor = () => {

    if (
        loteSelecionadoAuditorio?.value?.proximoLance <
        Number.parseFloat(desformatador(formLancePresencial.valorPresencial))
    ) {
        formLancePresencial.valorPresencial = formatador.format(
            Number.parseFloat(desformatador(formLancePresencial.valorPresencial)) -
            loteSelecionadoAuditorio?.value?.incrementoLote
        );
    } else {
        formLancePresencial.valorPresencial = formatador.format(
            loteSelecionadoAuditorio?.value?.proximoLance
        );
    }

};

const insereLancePresencial = async () => {
    formLancePresencial.valorPresencial = +desformatador(formLancePresencial.valorPresencial);

    $q.loading.show({
        message: "Gravando Lance Presencial...",
    });
    const resposta = await fetch(
        route("auditorio.lancePresencial", {
            idLeilao: leilaoSelecionadoAuditorio?.value?.id,
            idLote: loteSelecionadoAuditorio?.value?.id,
        }),
        {
            method: "POST",
            credentials: "include",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": document.head.querySelector(
                    'meta[name="csrf-token"]'
                ).content,
            },
            body: JSON.stringify(formLancePresencial.data()),
        }
    );

    const json = await resposta.json();
    placaIdentificacaoValida.value = json.mensagem === "OK";
    mensagemPlacaIdentificacaoValida.value = json.mensagem;

    formLancePresencial.identificacaoPresencial = "";
    formLancePresencial.valorPresencial = formatador.format(loteSelecionadoAuditorio?.value?.proximoLance)

    $q.loading.hide();
};

const idLeilaoNovo = ref(null);
const {
    abrirFixarEvent,
} = useAuditorio(
    props.leilao,
    props.loteSelecionadoInit,
    props.lotesInit,
    true,
    "moderador.mod.lote"
);
const mudarLeilao = async () => {
    isNavigating.value = true;
    abrirFixarEvent(null, idLeilaoNovo.value);
};


const mudaCorLance = ref(false);

watch(
    () => loteSelecionadoAuditorio?.value?.lances,
    (novo, antigo) => {

        if (novo?.[0]?.id_lote === antigo?.[0]?.id_lote &&
            novo?.[0]?.id !== antigo?.[0]?.id) {

            mudaCorLance.value = true;

            // Restaura a cor da div após 2 segundos
            setTimeout(() => {
                mudaCorLance.value = false;
            }, 2000);

        }
    }
);



watch(loteSelecionadoAuditorio, (newValue) => {

        incrementoLocal.value = newValue?.incremento * 100;
        lanceInicialLocal.value = leilaoSelecionadoAuditorio?.value?.primeiro_leilao_concluido === 1 &&
            +leilaoSelecionadoAuditorio?.value?.dois_leiloes === 1
            ? newValue?.lance_inicial_segundo_leilao * 100
            : newValue?.lance_inicial * 100;
        lanceMinimoLocal.value = newValue?.lance_minimo
            ? newValue?.lance_minimo * 100
            : lanceInicialLocal.value;

});

onBeforeUnmount(() => {
    auditorioStore.pararFila();
    leiloeiroAndou = () => {};
    leiloeiroMudouLeilao = () => {};

    callbackStatus = () => {};
    callbackUpdate = () => {};
    auditorioStore.redefinirLoteSelecionado(props.leilao.id);

    // Remove listeners de lote para evitar acúmulo (sem desconectar do canal)
    if (idLoteAtualSocket.value) {
        window.Echo.channel('realtime.status.lote')
            .stopListening('.lote.' + idLoteAtualSocket.value + '.status.atualizado');
        window.Echo.channel('realtime.update.lote')
            .stopListening('.lote.' + idLoteAtualSocket.value + '.atualizado');
    }
    // Remove listeners dos lotes valor-venda
    for (const id of idLotesValorVendaSocket.value) {
        if (id !== idLoteAtualSocket.value) {
            window.Echo.channel('realtime.status.lote')
                .stopListening('.lote.' + id + '.status.atualizado');
            window.Echo.channel('realtime.update.lote')
                .stopListening('.lote.' + id + '.atualizado');
        }
    }
    idLotesValorVendaSocket.value.clear();

    // Remove o binding de state_change para não acumular listeners entre navegações
    window.Echo.connector.pusher.connection.unbind('state_change', onStateChange);

    clearInterval(conexaoWebSocket.value);
    conexaoWebSocket.value = 0;

});

</script>
<template>
    <Head :title="'Auditorio - ' + loteSelecionadoAuditorio?.titulo" />
    <AuditorioLayoutV2>
        <q-page class="flex column bg-grey-3">
            <div class="full-width flex row justify-between items-center bg-primary" style="border-bottom: 5px solid rgb(194, 0, 11); height: 50px;">
               <div class="flex row full-height items-center">
                   <div class="flex q-px-md text-white">
                       <q-btn outline size="sm" class="q-mr-sm" @click="voltarPaginaLeilao">
                           <q-icon name="mdi-arrow-left" />
                       </q-btn>
                   </div>
                   <div class="text-white text-subtitle2" :class="$q.screen.gt.xs ? '' : 'text-subtitle2'" >
                       <template v-if="leilaoSelecionadoAuditorio">
                           <div class="flex">
                           Data: {{ formatDate(leilaoSelecionadoAuditorio?.data_hora_inicio) }}
                           </div>
                           <div class="flex" :style="$q.screen.lt.lg ? 'max-width: 400px;' : 'max-width: 60vw;'"
                           style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: inline-block;">
                           Leilão:
                           {{ leilaoSelecionadoAuditorio?.id }}
                           <template v-if="$q.screen.gt.sm">

                               "{{
                                   leilaoSelecionadoAuditorio?.titulo
                               }}"

                           </template>
                           </div>
                       </template>
                   </div>
               </div>

                <div class="full-height q-mr-md flex row justify-center items-center text-white">

                    <div class="q-pa-xs flex row items-center">
                        <div class="flex" v-if="$q.screen.gt.sm">
                            <q-btn
                                v-if="
                                statusIniciarLeilao.includes(
                                    leilaoSelecionadoAuditorio?.status_leilao?.identificador
                                )
                            "
                                size="12px"
                                style="background-color: #bccf30"
                                class="text-white hide-print full-width q-px-md"
                                label="INICIAR LEILÃO [I]"
                                @click="acoesLeilao.iniciarLeilao()"
                                dense
                            />
                            <q-btn
                                v-if="
                                statusEncerrarLeilao.includes(
                                    leilaoSelecionadoAuditorio?.status_leilao?.identificador
                                )
                            "
                                size="12px"
                                style="background-color: #ff0000"
                                class="text-white hide-print full-width q-px-md"
                                label="ENCERRAR LEILÃO [E]"
                                @click="acoesLeilao.encerrarLeilao()"
                                dense
                            />
                        </div>
                        <div class="q-pl-xs flex">
                            <q-btn-dropdown color="white" size="12px" dropdown-icon="mdi-menu" outline dense>
                                <q-list>
                                    <q-item-label header>Mais ações para leilão</q-item-label>

                                    <q-item clickable v-close-popup @click="acoesLeilao.iniciarLeilao()"
                                            v-if="
                                                    statusIniciarLeilao.includes(
                                                        leilaoSelecionadoAuditorio?.status_leilao?.identificador
                                                    )
                                                "
                                    >
                                        <q-item-section>
                                            <q-item-label>Iniciar Leilão</q-item-label>
                                        </q-item-section>
                                    </q-item>

                                    <q-item clickable v-close-popup @click="acoesLeilao.encerrarLeilao()" v-else
                                    >
                                        <q-item-section>
                                            <q-item-label>Encerrar Leilão</q-item-label>
                                        </q-item-section>
                                    </q-item>

                                    <q-item clickable v-close-popup @click="acoesLeilao.reabrirLeilao()">
                                        <q-item-section>
                                            <q-item-label>Reabrir Leilão</q-item-label>
                                        </q-item-section>
                                    </q-item>
                                </q-list>
                            </q-btn-dropdown>
                        </div>
                    </div>

                    <div class="q-pa-xs" v-if="$q.screen.gt.sm">

                        <q-btn
                            size="12px"
                            style="background-color: #31ccec"
                            class="text-white hide-print full-width q-px-md"
                            icon="mdi-page-next-outline"
                            dense
                        >
                            <q-popup-proxy style="overflow-y: hidden">
                                <q-banner style="width: 300px">
                                    <div
                                        class="full-width text-center q-mb-sm text-primary"
                                    >
                                        Mudar Leilão
                                    </div>
                                    <q-input
                                        label="Nº do Leilão"
                                        class="full-width q-mb-sm"
                                        v-model="idLeilaoNovo"
                                        dense
                                        outlined
                                    >
                                        <template v-slot:append>
                                            <q-btn
                                                color="positive"
                                                flat
                                                round
                                                @click="mudarLeilao"
                                                icon="mdi-arrow-right-box"
                                            />
                                        </template>
                                    </q-input>
                                </q-banner>
                            </q-popup-proxy>

                        </q-btn>
                    </div>

                    <div class="q-pa-xs">
                        <q-btn
                            v-if="+leilaoSelecionadoAuditorio?.chat_evento_iniciado === 0"
                            size="12px"
                            style="background-color: #bccf30"
                            class="text-white hide-print full-width q-px-md"
                            dense
                            @click="acoesLeilao.iniciarChatEvento()"
                            icon="mdi-chat-outline"
                        />
                        <q-btn
                            v-if="+leilaoSelecionadoAuditorio?.chat_evento_iniciado === 1"
                            size="12px"
                            style="background-color: #ff0000"
                            class="text-white hide-print full-width q-px-md"
                            dense
                            @click="acoesLeilao.interromperChatEvento()"
                            icon="mdi-chat-remove-outline"
                        />
                    </div>

                    <div class="q-pa-xs">
                        <q-btn
                            size="12px"
                            dense
                            style="background-color: #bccf30"
                            class="text-white hide-print full-width q-px-md"
                            v-if="+leilaoSelecionadoAuditorio?.transmissao_iniciada === 0"
                            @click="acoesLeilao.iniciarStream()"
                            icon="mdi-video-outline"
                        />
                        <q-btn
                            size="12px"
                            dense
                            style="background-color: #ff0000"
                            class="text-white hide-print full-width q-px-md"
                            @click="acoesLeilao.interromperStream()"
                            v-if="+leilaoSelecionadoAuditorio?.transmissao_iniciada === 1"
                            icon="mdi-video-off-outline"
                        />
                    </div>



                    <div class="q-pa-xs flex row items-center">

                            <template v-if="!isConnected && retryConnectSocket > maxRetryConnectSocket"> <q-icon name="mdi-circle" size="30px" class="text-red"/></template>
                            <template v-else-if="isConnected"> <q-icon name="mdi-circle" size="30px" class="text-white"/></template>
                            <template v-else><q-icon name="mdi-circle" size="30px" class="text-yellow"/></template>

                    </div>


                </div>
            </div>

            <div class="col-12 row bg-grey-3" >

                <div class="col-12 q-px-sm q-mt-sm row">
                    <div class="col-8">
                        <q-card class="q-px-md q-py-sm">
                            <div class="text-subtitle3 text-primary flex justify-between">
                                <span>Lotes</span>
                                <span class="text-caption">Legenda: <q-icon name="mdi-checkbox-blank" style="color: #BFD13B;"/> Vendido
                                    - <q-icon name="mdi-checkbox-blank" style="color: #FF0000;"/> Não Vendido
                                    - <q-icon name="mdi-checkbox-blank" style="color: #DB7313;"/> Condicional</span>
                            </div>

                            <div class="full-width flex no-wrap list-parent" style="overflow-x: auto">
                                <q-btn v-for="lote in listaLotesOrdenados"
                                       :key="lote.id"
                                       class="q-my-xs q-ml-none q-mr-sm"
                                       :unelevated="!(lote.id === loteSelecionadoAuditorio?.id)"
                                       square
                                       dense
                                       @click="acoesLote.irParaLote(lote.id)"
                                       style="width: 35px; height: 35px; flex-shrink: 0"
                                       :class="
                                    lote.id === loteSelecionadoAuditorio?.id
                                        ? `atual card-${lote.id}`
                                        : `card-${lote.id}`
                                "
                                       :style="`
                                 color: white;
                                 background-color: ${lote?.status_lote?.cor_site || '#00000073'};
                                 transform: ${
                                     lote.id === loteSelecionadoAuditorio?.id ? 'scale(1);' : 'scale(1);'
                                 }
                                 ${lote.id === loteSelecionadoAuditorio?.id ? 'border: solid 3px #00000073;' : ''}
                                 ${lote.id === loteSelecionadoAuditorio?.id ? '' : 'opacity: 0.95;'}
                                 `"
                                >
                                    {{ lote.sequencia }}
                                </q-btn>
                            </div>

                        </q-card>
                    </div>
                    <div class="col-4 q-pl-sm">
                        <q-card class="q-px-md q-py-sm">
                            <div class="text-subtitle3 text-primary flex justify-between">
                                <span>Valor de Venda</span>
                                <span class="text-caption">Legenda: <q-icon name="mdi-checkbox-blank" style="color: #BCCF30;"/> Venda Aceita
                                    - <q-icon name="mdi-checkbox-blank" style="color: #DB7313;"/> Venda em Aberto</span>
                            </div>

                            <div class="full-width flex no-wrap list-parent" style="overflow-x: auto; min-height: 43px;">
                                <q-btn v-for="lote in listaLotesValorVendaOrdenados"
                                       :key="lote.id"
                                       class="q-my-xs q-ml-none q-mr-sm"
                                       :unelevated="!(lote.id === loteSelecionadoAuditorio?.id)"
                                       square
                                       dense
                                       @click="abrirLoteAuditorio(lote.id)"
                                       style="width: 35px; height: 35px; flex-shrink: 0"
                                       :class="
                                    lote.id === loteSelecionadoAuditorio?.id
                                        ? `atual card-${lote.id}`
                                        : `card-${lote.id}`
                                "
                                       :style="`
                                 color: white;
                                 background-color: ${ (lote?.status_lote?.identificador === 'CONDICIONAL') ? '#BCCF30' : lote?.status_lote?.cor_site || '#00000073'};
                                 transform: ${
                                     lote.id === loteSelecionadoAuditorio?.id ? 'scale(1);' : 'scale(1);'
                                 }
                                 ${lote.id === loteSelecionadoAuditorio?.id ? 'border: solid 3px #00000073;' : ''}
                                 ${lote.id === loteSelecionadoAuditorio?.id ? '' : 'opacity: 0.95;'}
                                 `"
                                >
                                    {{ lote.sequencia }}
                                </q-btn>
                            </div>

                        </q-card>
                    </div>

                </div>

                <div class="flex row full-width" :style="$q.screen.lt.md ? 'flex-direction: column-reverse' : '' ">
                    <div class="bg-grey-3 row q-py-sm q-pl-sm q-pr-none"
                         :class="$q.screen.lt.md ? 'col-12' : 'col-8' "
                    >
                        <div class="col-12 row">
                            <div class="bg-grey-3 q-pr-sm" :class="$q.screen.lt.md ? 'col-12' : 'col-6'">
                                <q-card class="col-12">
                                    <q-btn
                                        color="primary"
                                        style="position: absolute; width: 25px; left: 10px; top: 10px; z-index: 999;"
                                        @click="visualizarImagens = !visualizarImagens">
                                        <q-icon v-if="!visualizarImagens" name="mdi-chat" />
                                        <q-icon v-else name="mdi-image" />
                                    </q-btn>

                                    <q-card-section class="q-pa-none q-mb-xs flex row " v-show="visualizarImagens === false">
                                        <q-carousel
                                        class="override-index full-width"
                                        v-model="slide"
                                        :autoplay="false"
                                        animated
                                        arrows

                                        control-color="white"
                                        control-text-color="primary"
                                        control-type="push"
                                        next-icon="mdi-chevron-right"
                                        prev-icon="mdi-chevron-left"
                                        infinite
                                        swipeable
                                        :class="$q.screen.gt.sm ? 'col-5' : 'col-12'"
                                        @mouseenter="autoplay = false"
                                        @mouseleave="autoplay = true"
                                    >
                                        <q-carousel-slide
                                            v-for="(imagem, key) in lote?.imagens_lote &&
                        loteSelecionadoAuditorio?.imagens_lote.length > 0
                            ? loteSelecionadoAuditorio?.imagens_lote
                            : leilaoSelecionadoAuditorio?.comitente?.arquivo_capa_padrao
                            ? [
                                  {
                                      arquivo:
                                          leilaoSelecionadoAuditorio?.comitente?.arquivo_capa_padrao,
                                  },
                              ]
                            : []"
                                            :key="key"
                                            :name="
                            1 + key
                        "
                                            style="
                            background-position: center;
                            background-size: cover;
                            background-repeat: no-repeat;
                        "
                                            class="q-pa-none"
                                        >
                                            <q-img
                                                class="full-width full-height"
                                                loading="lazy"
                                                :src="
                                getImagem(
                                    imagem?.arquivo,
                                    true,
                                    loteSelecionadoAuditorio?.status_lote?.identificador
                                )
                            "
                                                :ratio="16 / 9"
                                            >
                                                <template v-slot:error>
                                                    <div
                                                        class="absolute-full flex flex-center bg-primary text-white"
                                                    >
                                                        Houve um problema carregando a imagem
                                                    </div>
                                                </template>
                                                <template v-slot:loading>
                                                    <div
                                                        class="absolute-full flex column flex-center bg-white text-primary"
                                                    >

                                                        <p class="q-mt-sm">
                                                            <q-spinner size="sm" class="q-pr-sm" />
                                                            Carregando imagem...
                                                        </p>
                                                    </div>
                                                </template>
                                            </q-img>
                                        </q-carousel-slide>
                                    </q-carousel>
                                    </q-card-section>


                                        <q-card-section class="q-pa-none q-mb-xs flex row" v-show="visualizarImagens === true"
                                        style="height: 80vh; min-height: 60px">
                                            <iframe
                                                v-show="leilaoSelecionadoAuditorio?.chat_url_evento"
                                                :src="leilaoSelecionadoAuditorio?.chat_url_evento ? `${leilaoSelecionadoAuditorio?.chat_url_evento}&remover_chat=0` : 'about:blank'"
                                                style="width: 100%; height: 100%; border: none"
                                            ></iframe>
                                        </q-card-section>

                                </q-card>



                                <div class="col-12">
                                    <q-card class="q-mt-sm q-pa-md" style="min-height: 405px;">
                                        <div class="text-primary text-subtitle1">Lote nº {{ formatadorLote(+loteSelecionadoAuditorio?.sequencia) }}</div>
                                        <div class="text-primary text-h6">{{ loteSelecionadoAuditorio?.titulo }}</div>
                                        <q-separator class="q-my-md"/>
                                        <div class="text-primary">Descrição:</div>
                                        <div v-html="descricaoLote"> </div>
                                    </q-card>
                                </div>


                            </div >
                            <!-- 3 -->
                            <div class="bg-grey-3" :class="$q.screen.lt.md ? 'col-12' : 'col-6'">
                                <q-card class=" q-pa-md">


                                    <div class="text-primary text-subtitle1 row col-12">
                                        <div class="col-4 row">
                                            <span class="col-12">Lote nº {{ formatadorLote(+loteSelecionadoAuditorio?.sequencia || 0 )  }} </span>
                                        </div>
                                        <div class="col-8 row justify-end">

                                            <div >
                                                <q-checkbox v-model="checkLiberaBotoes" @click="liberaBotoes"/>
                                            </div>
                                            <div class="q-ml-sm flex flex-center">
                                                <q-btn-dropdown color="primary" :label="$q.screen.gt.md ? 'Mais' : ''" class="q-mr-sm" dropdown-icon="mdi-menu" size="12px" outline>
                                                    <q-list>
                                                        <q-item-label header>Mais ações para lote</q-item-label>
                                                        <q-item clickable v-close-popup @click="acoesLote.retirarLote()">
                                                            <q-item-section>
                                                                <q-item-label>Retirar Lote</q-item-label>
                                                            </q-item-section>
                                                        </q-item>
                                                    </q-list>
                                                </q-btn-dropdown>
                                            </div>
                                            <div class="q-ml-sm flex flex-center">
                                                <q-btn
                                                    icon="mdi-chevron-left"
                                                    @click="acoesLote.anterior()"
                                                    outline
                                                    dense
                                                    size="12px"
                                                />
                                            </div>

                                            <div class="q-ml-sm flex flex-center">
                                                <q-btn
                                                    icon="mdi-chevron-right"
                                                    @click="acoesLote.proximo()"
                                                    outline
                                                    dense
                                                    size="12px"
                                                />
                                            </div>


                                        </div>
                                    </div>


                                    <q-separator class="q-my-md"/>
                                    <div class="flex justify-center row full-width col-12 q-pa-none" >

                                            <div class="q-pa-xs" :class="$q.screen.lt.md ? 'col-6' : 'col-6'">

                                                <q-btn
                                                    style="background-color: #31ccec"
                                                    class="text-white hide-print full-width"
                                                    label="ABRIR LOTE [A]"
                                                    @click="acoesLote.aberto()"
                                                />
                                            </div>
                                            <div class="q-pa-xs" :class="$q.screen.lt.md ? 'col-6' : 'col-6'">
                                                <q-btn
                                                    style="background-color: #043668"
                                                    class="text-white hide-print full-width"
                                                    label="EM PREGÃO [P]"
                                                    @click="acoesLote.pregao()"
                                                />
                                            </div>
                                            <div class="q-pa-xs" :class="$q.screen.lt.md ? 'col-6' : 'col-6'">
                                                <q-btn
                                                    style="background-color: #e0607e"
                                                    class="text-white hide-print full-width"
                                                     label="DOULHE UMA [U]"
                                                    @click="acoesLote.doulheUma()"
                                                />
                                            </div>
                                            <div class="q-pa-xs" :class="$q.screen.lt.md ? 'col-6' : 'col-6'">
                                                <q-btn
                                                    style="background-color: #ca054d"
                                                    class="text-white hide-print full-width"
                                                     label="DOULHE DUAS [D]"
                                                    @click="acoesLote.doulheDuas()"
                                                />
                                            </div>
                                            <div class="q-pa-xs" :class="$q.screen.lt.md ? 'col-6' : 'col-6'">
                                                <q-btn
                                                    style="background-color: #e0607e"
                                                    class="text-white hide-print full-width"
                                                    label="PROPOSTA UMA [U]"
                                                    @click="acoesLote.propostaUma()"
                                                />
                                            </div>
                                            <div class="q-pa-xs" :class="$q.screen.lt.md ? 'col-6' : 'col-6'">
                                                <q-btn
                                                    style="background-color: #ca054d"
                                                    class="text-white hide-print full-width"
                                                    label="PROPOSTA DUAS [D]"
                                                    @click="acoesLote.propostaDuas()"
                                                />
                                            </div>
                                            <div class="q-pa-xs" :class="$q.screen.lt.md ? 'col-6' : 'col-6'">
                                                <q-btn
                                                    :style="(!statusVendido.includes(loteSelecionadoAuditorio?.status_lote?.identificador) && !checkLiberaBotoes)
                                                                ? 'background-color: #cccccc'
                                                                : 'background-color: #bccf30'
                                                        "

                                                    class="text-white hide-print full-width"
                                                     label="VENDIDO [V]"
                                                    @click="acoesLote.vendido()"
                                                    :disabled="!statusVendido.includes(loteSelecionadoAuditorio?.status_lote?.identificador) && !checkLiberaBotoes"
                                                />
                                            </div>
                                            <div class="q-pa-xs" :class="$q.screen.lt.md ? 'col-6' : 'col-6'">
                                                <q-btn
                                                    style="background-color: #ff0000"
                                                    class="text-white hide-print full-width"
                                                    label="NÃO VENDIDO [N]"
                                                    @click="acoesLote.naoVendido()"
                                                />
                                            </div>
                                            <div class="q-pa-xs" :class="$q.screen.lt.md ? 'col-6' : 'col-6'">
                                                <q-btn

                                                    :style="(!statusCondicional.includes(loteSelecionadoAuditorio?.status_lote?.identificador) && !checkLiberaBotoes)
                                                                ? 'background-color: #cccccc'
                                                                : 'background-color: #ff6c2f'
                                                        "
                                                    class="text-white hide-print full-width"
                                                    label="CONDICIONAL [C]"
                                                    @click="acoesLote.condicional()"
                                                    :disabled="!statusCondicional.includes(loteSelecionadoAuditorio?.status_lote?.identificador) && !checkLiberaBotoes"
                                                />
                                            </div>
                                            <div class="q-pa-xs" :class="$q.screen.lt.md ? 'col-6' : 'col-6'">
                                                <q-btn
                                                    style="background-color: #ffcc33"
                                                    class="text-white hide-print full-width"
                                                    label="REPASSE [R]"
                                                    @click="acoesLote.repasse()"
                                                />
                                            </div>

                                    </div>
                                    <q-separator class="q-my-md"/>

                                    <div class="text-primary text-subtitle1">Alterar Valor</div>
                                    <q-separator class="q-my-md"/>
                                    <div class="flex justify-center row full-width col-12">
                                        <div class="flex col col-6 q-pa-sm">
                                            <q-input
                                                outlined
                                                dense
                                                prefix="R$"
                                                mask="####.###.###,##"
                                                reverse-fill-mask
                                                unmasked-value
                                                class="full-width"
                                                v-model="lanceInicialLocal"
                                                @keyup="lanceInicialLocalSalvo = false"
                                                label="Lance Inicial"
                                            >
                                                <template #append>
                                                    <q-btn
                                                        v-if="lanceInicialLocalSalvo"
                                                        color="positive"
                                                        flat
                                                        disabled
                                                        dense
                                                        round
                                                        icon="mdi-content-save-check"
                                                    />
                                                    <q-btn
                                                        v-else
                                                        color="warning"
                                                        flat
                                                        dense
                                                        round
                                                        @click="salvarLanceInicial"
                                                        icon="mdi-content-save-alert"
                                                    />
                                                </template>
                                            </q-input>
                                        </div>
                                        <div class="flex row col-6 q-pa-sm">
                                            <div class="col-10 q-pr-sm">
                                                <q-input
                                                    outlined
                                                    dense
                                                    prefix="R$"
                                                    mask="####.###.###,##"
                                                    reverse-fill-mask
                                                    unmasked-value
                                                    class="full-width"
                                                    @keyup="incrementoLocalSalvo = false"
                                                    v-model="incrementoLocal"
                                                    label="Incremento"
                                                >
                                                    <template #append>
                                                        <q-btn
                                                            v-if="incrementoLocalSalvo"
                                                            color="positive"
                                                            flat
                                                            disabled
                                                            dense
                                                            round
                                                            icon="mdi-content-save-check"
                                                        />
                                                        <q-btn
                                                            v-else
                                                            color="warning"
                                                            flat
                                                            dense
                                                            round
                                                            @click="salvarIncremento"
                                                            icon="mdi-content-save-alert"
                                                        />
                                                    </template>
                                                </q-input>
                                            </div>
                                            <div class="col-2">
                                                <q-btn-dropdown color="primary" class="q-mr-sm fit" dropdown-icon="mdi-menu" outline dense>
                                                    <q-list>
                                                        <q-item-label header>Incremento Rápido</q-item-label>
                                                        <q-item clickable v-close-popup @click="incrementoRapido(50)">
                                                            <q-item-section>
                                                                <q-item-label>R$ 50,00</q-item-label>
                                                            </q-item-section>
                                                        </q-item>
                                                        <q-item clickable v-close-popup @click="incrementoRapido(100)">
                                                            <q-item-section>
                                                                <q-item-label>R$ 100,00</q-item-label>
                                                            </q-item-section>
                                                        </q-item>
                                                        <q-item clickable v-close-popup @click="incrementoRapido(200)">
                                                            <q-item-section>
                                                                <q-item-label>R$ 200,00</q-item-label>
                                                            </q-item-section>
                                                        </q-item>
                                                        <q-item clickable v-close-popup @click="incrementoRapido(400)">
                                                            <q-item-section>
                                                                <q-item-label>R$ 400,00</q-item-label>
                                                            </q-item-section>
                                                        </q-item>
                                                        <q-item clickable v-close-popup @click="incrementoRapido(500)">
                                                            <q-item-section>
                                                                <q-item-label>R$ 500,00</q-item-label>
                                                            </q-item-section>
                                                        </q-item>
                                                        <q-item clickable v-close-popup @click="incrementoRapido(1000)">
                                                            <q-item-section>
                                                                <q-item-label>R$ 1.000,00</q-item-label>
                                                            </q-item-section>
                                                        </q-item>
                                                        <q-item clickable v-close-popup @click="incrementoRapido(5000)">
                                                            <q-item-section>
                                                                <q-item-label>R$ 5.000,00</q-item-label>
                                                            </q-item-section>
                                                        </q-item>
                                                        <q-item clickable v-close-popup @click="incrementoRapido(10000)">
                                                            <q-item-section>
                                                                <q-item-label>R$ 10.000,00</q-item-label>
                                                            </q-item-section>
                                                        </q-item>
                                                    </q-list>
                                                </q-btn-dropdown>
                                            </div>

                                        </div>
                                        <div class="flex col col-6 q-pa-sm">
                                            <q-input
                                                outlined
                                                dense
                                                prefix="R$"
                                                mask="####.###.###,##"
                                                reverse-fill-mask
                                                unmasked-value
                                                class="full-width"
                                                @keyup="lanceMinimoLocalSalvo = false"
                                                v-model="lanceMinimoLocal"
                                                label="Mínimo Comitente"
                                            >
                                                <template #append>
                                                    <q-btn
                                                        v-if="lanceMinimoLocalSalvo"
                                                        color="positive"
                                                        flat
                                                        disabled
                                                        dense
                                                        round
                                                        icon="mdi-content-save-check"
                                                    />
                                                    <q-btn
                                                        v-else
                                                        color="warning"
                                                        flat
                                                        dense
                                                        round
                                                        @click="salvarLanceMinimo"
                                                        icon="mdi-content-save-alert"
                                                    />
                                                </template>
                                            </q-input>
                                        </div>
                                        <div class="flex col col-6 q-pa-sm">
                                            <q-btn
                                                v-if="
                                                    loteSelecionadoAuditorio?.status_lote?.identificador !==
                                                    'CONDICIONAL_REABERTA'
                                                "
                                                style="background-color: #31ccec"
                                                class="text-white hide-print full-width"
                                                label="ABRIR VALOR DE VENDA"
                                                :disable="disableBtnAvisarValorVenda"
                                                @click="reabrirCondicionalVenda"
                                            />
                                            <q-btn
                                                v-else
                                                color="negative"
                                                class="text-white hide-print full-width"
                                                label="Encerrar Valor de Venda"
                                                @click="encerrarCondicionalVenda"
                                            />

                                        </div>
                                    </div>
                                    <q-separator class="q-my-md"/>

                                    <div class="text-primary text-subtitle1">Lance Presencial</div>
                                    <q-separator class="q-my-md"/>

                                        <q-form
                                            class="flex justify-center row full-width col-12"
                                            @submit="insereLancePresencial"
                                            >
                                            <div class="flex col col-6 q-pa-sm">
                                                <q-input
                                                    v-model="formLancePresencial.identificacaoPresencial"
                                                    outlined
                                                    dense
                                                    reverse-fill-mask
                                                    unmasked-value
                                                    class="full-width"
                                                    label="Placa"
                                                    :error="!placaIdentificacaoValida"
                                                    :error-message="mensagemPlacaIdentificacaoValida"
                                                />
                                            </div>
                                            <div class="flex col col-6 q-pa-sm">
                                                   <q-input
                                                    v-model="formLancePresencial.valorPresencial"
                                                    outlined
                                                    dense
                                                    prefix="R$"
                                                    mask="###.###.###.###,##"
                                                    reverse-fill-mask
                                                    class="full-width"
                                                    label="Valor Lance Presencial"
                                                    input-class="text-right"
                                                    :error="!placaIdentificacaoValida"
                                                    :error-message="mensagemPlacaIdentificacaoValida"
                                                    :rules="[
                                                        () =>
                                                        Number.parseFloat(desformatador(
                                                        formLancePresencial.valorPresencial
                                                        )) >=
                                                        (loteSelecionadoAuditorio
                                                        ?.proximoLance) ||
                                                        'Valor deve ser maior do que o lance anterior',
                                                    ]"
                                                >
                                                    <template v-slot:append>
                                                        <q-btn
                                                            icon="mdi-minus-box"
                                                            @click="
                                                            decrementarValor
                                                        "
                                                            round
                                                            flat
                                                            dense
                                                        />
                                                        <q-btn
                                                            icon="mdi-plus-box"
                                                            @click="
                                                            incrementarValor
                                                        "
                                                            round
                                                            flat
                                                            dense
                                                        />
                                                    </template>
                                                 </q-input>
                                            </div>
                                            <div class="flex col col-12 q-pa-sm">
                                                <q-btn
                                                    style="background-color: #bccf30"
                                                    class="text-white hide-print full-width"
                                                    label="ADICIONAR LANCE PRESENCIAL"
                                                    type="submit"
                                                />

                                            </div>

                                        </q-form>


                                </q-card>
                            </div>
                        </div>

                    </div>

                    <div class="bg-grey-3 q-pa-sm"
                         :class="$q.screen.lt.md ? 'col-12' : 'col-4' ">
                        <div class="col-12 q-mb-sm" v-if="loteSelecionadoAuditorio?.sequencia && $q.screen.lt.md">
                            <q-card>
                                <q-card-section class="text-center text-subtitle1 text-primary">
                                    Lote nº {{ formatadorLote(+loteSelecionadoAuditorio?.sequencia || 0 )  }}
                                </q-card-section>
                            </q-card>
                        </div>

<!--                        <KeepAlive :key="urlVideo">-->
<!--                            <div class="col-12"  v-if="urlVideo" v-show="+leilaoSelecionadoAuditorio?.transmissao_iniciada === 1">-->
<!--                                <q-card >-->
<!--                                    <q-card-section class="q-pb-none">-->
<!--                                        <div class="text-subtitle1 text-primary">Ao Vivo</div>-->
<!--                                    </q-card-section>-->
<!--                                    <q-card-section>-->
<!--                                        <q-video-->

<!--                                            :ratio="16/9"-->
<!--                                            :src="urlVideo"-->
<!--                                        />-->
<!--                                    </q-card-section>-->
<!--                                </q-card>-->
<!--                            </div>-->
<!--                        </KeepAlive>-->

                        <div class="col-12" v-if="+leilaoSelecionadoAuditorio?.fechamento_automatico === 0 &&
                                loteSelecionadoAuditorio?.timer_moderador && timerModerador">
                            <q-card class="q-mt-sm text-primary"

                            >
                                <q-card-section>
                                    <div class="text-h6 text-center"><q-icon name="mdi-timer" color="primary" size="sm" class="q-mr-md"/>{{timerModerador}}</div>
                                </q-card-section>
                            </q-card>
                        </div>
                        <div class="col-12 ">
                            <q-card
                                    :style="`background-color: ${loteSelecionadoAuditorio?.status_lote?.cor_site};`"
                                    style="color: white;"
                            >
                                <q-card-section class="q-ma-none q-pa-xs">
                                    <div class="text-h6 text-center">{{loteSelecionadoAuditorio?.status_lote?.nome}}</div>
                                </q-card-section>
                            </q-card>
                        </div>
                        <div class="col-12" v-if="loteSelecionadoAuditorio?.lances?.[0]?.valor">
                            <q-card class="q-mt-sm">
                                <q-card-section class="text-center"
                                                :class="{
                                                    'bg-positive': mudaCorLance,
                                                    'blink': mudaCorLance,
                                                }"

                                >
                                    <div class="text-h6 text-primary">{{formatador.format(loteSelecionadoAuditorio?.lances?.[0]?.valor || valorLanceAtual)}}</div>
                                    <div class="text-subtitle3" v-if="loteSelecionadoAuditorio?.lances?.[0]">
                                        às {{formatDate(loteSelecionadoAuditorio?.lances?.[0]?.data_hora)}}
                                    </div>
                                    <div class="text-subtitle3" v-if="loteSelecionadoAuditorio?.lances?.[0]">
                                        Por {{ loteSelecionadoAuditorio?.lances?.[0]?.cliente?.usuario?.username }}

                                        <template
                                            v-if="loteSelecionadoAuditorio?.lances?.[0]?.cliente?.enderecos_cliente?.length > 0"
                                        >
                                            de

                                            {{
                                                loteSelecionadoAuditorio?.lances?.[0]?.cliente?.enderecos_cliente?.[0]?.rua?.bairro?.cidade?.nome ||
                                                loteSelecionadoAuditorio?.lances?.[0]?.cliente?.enderecos_cliente?.[0]?.cidade_endereco
                                            }}
                                            /
                                            {{
                                                loteSelecionadoAuditorio?.lances?.[0]?.cliente?.enderecos_cliente?.[0]?.rua?.bairro?.cidade?.estado?.codigo_uf ||
                                                loteSelecionadoAuditorio?.lances?.[0]?.cliente?.enderecos_cliente?.[0]?.uf_endereco
                                            }}
                                        </template>

                                    </div>
                                </q-card-section>
                            </q-card>
                        </div>

                        <div class="col-12">
                            <q-card class="q-mt-sm">
                                <q-card-section>
                                    <div class="text-subtitle1 text-primary">Últimos Lances</div>
                                </q-card-section>
                                <q-card-section v-if="!(+loteSelecionadoAuditorio?.lances?.length > 0)" style="font-size: 10px;">
                                    Nenhum lance registrado.
                                </q-card-section>
                                <q-card-section class="q-pt-none" v-else>
                                    <q-scroll-area
                                        class="full-width"
                                        style="height: 470px; "
                                    >
                                        <div class="q-pa-none full-width" >
                                            <q-markup-table>
                                                <thead>
                                                <tr style="height: auto;">
                                                    <th class="text-left text-bold" style="height: auto; font-size: 10px;">Lance</th>
                                                    <th class="text-left text-bold" style="height: auto; font-size: 10px;">Apelido</th>
                                                    <th class="text-left text-bold" style="height: auto; font-size: 10px;">Valor</th>
                                                    <th class="text-left text-bold" style="height: auto; font-size: 10px;"></th>
                                                </tr>
                                                </thead>
                                                <tbody>

                                                <tr v-for="(lance, idx) in loteSelecionadoAuditorio?.lances" :key="idx" style="height: auto;">
                                                    <td class="text-left" style="height: auto; font-size: 10px;">{{ (+qtdLances - +idx) }}</td>
                                                    <td class="text-left" style="height: auto; font-size: 10px;">{{lance?.cliente?.usuario?.username}} <br/> em {{formatDate(lance?.data_hora)}}</td>
                                                    <td class="text-left" style="height: auto; font-size: 10px;">{{ formatador.format(lance?.valor) }}
                                                        <br/>
                                                        <template v-if="lance?.id_lance_automatico_registrado">
                                                            Automático
                                                        </template>
                                                        <template v-else>
                                                            Manual
                                                        </template>
                                                    </td>
                                                    <td class="text-left" style="height: auto; font-size: 10px;"><q-icon name="mdi-delete-outline" color="red" size="20px" class="cursor-pointer" @click="mostrarModalRemoverLance(lance?.id)" /></td>
                                                </tr>

                                                </tbody>
                                            </q-markup-table>
                                        </div>
                                    </q-scroll-area>
                                </q-card-section>

                            </q-card>
                        </div>

                    </div>
                </div>
            </div>

            <q-dialog v-model="confirmExclusaoLance" persistent>
                <q-card>
                    <q-item>
                        <q-item-section avatar>
                            <q-avatar
                                icon="mdi-trash-can"
                                color="red"
                                text-color="white"
                                class="q-mb-sm"
                            />
                        </q-item-section>

                        <q-item-section>
                            <q-item-label class="text-h6"
                            >Excluir Lance</q-item-label
                            >
                        </q-item-section>
                    </q-item>

                    <q-card-section class="row items-center">
                    <span class="q-ml-sm"
                    >Ao clicar em confirmar este lance será excluído
                        permanentemente, não sendo possível sua recuperação.
                    </span>
                    </q-card-section>

                    <q-card-actions align="right">
                        <q-btn
                            flat
                            label="Cancelar"
                            color="primary"
                            v-close-popup
                            @click="resetaForm"
                        />
                        <q-btn
                            flat
                            label="Confirmar"
                            color="red"
                            @click="removerLance"
                        />
                    </q-card-actions>
                </q-card>
            </q-dialog>


        </q-page>
    </AuditorioLayoutV2>
</template>
<style scoped>

    ::-webkit-scrollbar {
        right: 0;
        border-radius: 5px;
        background-color: transparent;
        height: 10px;
        opacity: 0.5;
    }

    ::-webkit-scrollbar-thumb {
        cursor: pointer;
        border-radius: 9px;
        background: rgba(0, 0, 0, 0.15);
    }

    .blink {
        animation: blink 1s steps(1, end) 3s;
    }

    @keyframes blink {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

</style>
